module.exports = __webpack_public_path__ + "img/sk-partners-sme.ab020da7.png";